import { Language } from '@/types';
import { ApiDefinition, Feature } from '../types/api-definitions';

export const buildApiUrl = (path: string): string => {
  const baseUrl = (window.ENV?.API_BASE_URL || import.meta.env.VITE_API_BASE_URL || '').replace(/\/+$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${normalizedPath}`;
};

export const isRelativeUrl = (url: string | undefined): boolean => {
  if (!url){
    return false;
  }

  if (url.startsWith('//')){
    return false;
  }

  if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(url)){
    return false;
  }

  return true;
};

export const transformMediaUrl = (url: string | undefined): string => {
  if (!url) {
    return '';
  }

  if (isRelativeUrl(url)) {
    const normalizedPath = url.startsWith('/') ? url : `/${url}`;
    return buildApiUrl(normalizedPath);
  }

  return url;
};

export const getLocalizedContent = (apiDefinition: ApiDefinition, selectedLanguage: Language) => {
  return (
    apiDefinition.authoredContent[selectedLanguage] ||
    apiDefinition.authoredContent[Language.EN] ||
    apiDefinition.authoredContent[Language.NL]
  );
};

export const getLocalizedFeatureContent = (apiDefinition: ApiDefinition, selectedLanguage: Language) => {
  const allFeatures = Object.values(apiDefinition.authoredContent).flatMap((content) => content?.features || []);

  const featureMap = new Map<string, Feature[]>();
  for (const feature of allFeatures) {
    const existing = featureMap.get(feature.slug);
    if (existing) {
      existing.push(feature);
    } else {
      featureMap.set(feature.slug, [feature]);
    }
  }

  return Array.from(featureMap.values()).map((features) => {
    return features.find((f) => f.locale === selectedLanguage) ||
      features.find((f) => f.locale === Language.EN) ||
      features[0];
  }).filter(Boolean);
};